import React, { useEffect, useState } from 'react';
import { useHistory, NavLink } from "react-router-dom";
import { State, City } from 'country-state-city';
import MyDropzone from "../components/MyDropzone";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Select from 'react-select';
import axios from 'axios';
import { BASEURL } from '../Config';
import swal from 'sweetalert';

const AddSchoolData = (props) => {
    const history = useHistory(); 
    const { uuid } = props;
    const heading = uuid ? 'Edit School Data' : 'Add School Data';
    const [distributors, setDistributors] = useState("");
    const [schoolName, setSchoolName] = useState("");
    const [contactPersonName, setContactPersonName] = useState("");
    const [contactPersonDesignation, setContactPersonDesignation] = useState("");
    const [cellNo, setCellNo] = useState("");
    const [officeNo, setOfficeNo] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [stateName, setStateName] = useState("");
    const [city, setCity] = useState("");
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [strengthLKGTo5th, setStrengthLKGTo5th] = useState(0);
    const [strengthLKGTo10th, setStrengthLKGTo10th] = useState(0);
    const [boardType, setBoardType] = useState("");
    const [currentPublisher, setCurrentPublisher] = useState("");
    const [currentDistributor, setCurrentDistributor] = useState("");
    const [currentDistributorUUID, setCurrentDistributorUUID] = useState("");
    const [bookSellingType, setBookSellingType] = useState("");
    const [notes, setNotes] = useState("");
    // const [schoolPictures, setSchoolPictures] = useState([]);
    const [schoolPic, setSchoolPic] = useState("");

    // Error states are not added for simplicity but can be added similar to previous examples.
    
    const [schoolPicError, setSchoolPicError] = useState(false);
    const [schoolNameError, setSchoolNameError] = useState(false);
    const [stateError, setStateError] = useState(false);
    const [cityError, setCityError] = useState(false);

    useEffect(() => {
        const states = State.getStatesOfCountry('IN').map(state => { return { name: state.name, isoCode: state.isoCode }});
        setStates(states);
        getDistributors();
    }, []);

    useEffect(() => {
        if (uuid) {
            fetchSchoolData();
        }
    }, [uuid, distributors]);

    const fetchSchoolData = async () => {
        try {
            const response = await axios.get(`${BASEURL}/api/v1/salesSchool/${uuid}`);
            if (response.status === 200) {
                const data = response.data;
                setSchoolName(data.schoolName || '');
                setContactPersonName(data.contactPersonName || '');
                setContactPersonDesignation(data.contactPersonDesignation || '');
                setCellNo(data.cellNo || '');
                setOfficeNo(data.officeNo || '');
                setAddress(data.address || '');
                setStateName(data.state || '');
                
                // Find state isoCode from state name
                const stateObj = State.getStatesOfCountry('IN').find(s => s.name === data.state);
                if (stateObj) {
                    setState(stateObj.isoCode);
                    const cities = City.getCitiesOfState('IN', stateObj.isoCode).map(city => city.name);
                    setCities(cities);
                }
                
                setCity(data.city || '');
                setStrengthLKGTo5th(data.strengthLKGTo5th || 0);
                setStrengthLKGTo10th(data.strengthLKGTo10th || 0);
                setBoardType(data.boardType || '');
                setCurrentPublisher(data.currentPublisher || '');
                setCurrentDistributorUUID(data.currentDistributor || '');
                
                // Set the distributor select value if distributors are loaded
                if (data.currentDistributor && distributors && distributors.length > 0) {
                    const dist = distributors.find(d => d.value === data.currentDistributor);
                    if (dist) {
                        setCurrentDistributor(dist);
                    }
                }
                
                setBookSellingType(data.bookSellingType || '');
                setNotes(data.notes || '');
                setSchoolPic(data.schoolPic || '');
            }
        } catch (err) {
            console.error('Error fetching school data:', err);
            swal('Error', 'Failed to fetch school data', 'error');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "schoolName") {
            setSchoolName(value);
        } else if (name === "contactPersonName") {
            setContactPersonName(value);
        } else if (name === "contactPersonDesignation") {
            setContactPersonDesignation(value);
        } else if (name === "cellNo") {
            setCellNo(value);
        } else if (name === "officeNo") {
            setOfficeNo(value);
        } else if (name === "address") {
            setAddress(value);
        } else if (name === "state") {
            setState(value);
            setStateName(states.find(state => state.isoCode === value)?.name || '');
            const cities = City.getCitiesOfState('IN', value).map(city => city.name);
            setCities(cities);
            // setStateError(false);
        } else if (name === "city") {
            setCity(value);
            // setCityError(false);
        } else if (name === "strengthLKGTo5th") {
            setStrengthLKGTo5th(value);
        } else if (name === "strengthLKGTo10th") {
            setStrengthLKGTo10th(value);
        } else if (name === "boardType") {
            setBoardType(value);
        } else if (name === "currentPublisher") {
            setCurrentPublisher(value);
        } 
        // else if (name === "currentDistributor") {
        //     setCurrentDistributor(value);
        //     setCurrentDistributorUUID(value.uuid);
        // } 
        else if (name === "bookSellingType") {
            setBookSellingType(value);
        } else if (name === "notes") {
            setNotes(value);
        }
    };

    const handleChangeDistributor = selectedOptions => {
        setCurrentDistributor(selectedOptions);
        setCurrentDistributorUUID(selectedOptions.value);
    };

    const getDistributors = () => {
        axios.get(`${BASEURL}/api/v1/distributor`)
            .then(res => {
                if (res.status === 200) {
                    const data = res.data.map(item => { return { label: item.name, value: item.uuid }});
                    setDistributors(data);
                }
            })
            .catch((err) => {
                console.log(err.response.data);
            })
    }

    // validateData 
    const validateData = () => {
        let error = false;
        if (schoolName === "" || schoolName === undefined) {
          setSchoolNameError(true);
          error = true;
        }
        if (stateName === "" || stateName === undefined) {
            setStateError(true);
            error = true;
        }
        if (city === "" || city === undefined) {
            setCityError(true);
            error = true;
        }
        return error;
    }

    const handleSubmit = () => {
        let validationError = validateData();
        if (validationError) {
            swal('Error in Creating School', 'Fill the required fields', 'error');
        } else {
            const inputObj = {
                schoolName: schoolName,
                contactPersonName: contactPersonName,
                contactPersonDesignation: contactPersonDesignation,
                cellNo: cellNo,
                officeNo: officeNo,
                address: address,
                state: stateName,
                city: city,
                strengthLKGTo5th: strengthLKGTo5th,
                strengthLKGTo10th: strengthLKGTo10th,
                boardType: boardType,
                currentPublisher: currentPublisher,
                currentDistributor: currentDistributorUUID,
                bookSellingType: bookSellingType,
                notes: notes,
                schoolPic: schoolPic,
                createdBy: 'admin'
            };
            if (uuid) {
                axios.put(`${BASEURL}/api/v1/salesSchool/${uuid}`, inputObj)
                    .then(res => {
                        if (res.status === 200) {
                            swal("Success", "School Updated successfully", "success")
                                .then(function () {
                                    history.push("/schoolsData");
                                })
                        }
                    })
                    .catch((err) => {
                        swal('Error in Updating School', err.response?.data || 'Failed to update', 'error');
                        console.log('Update School Error', err);
                    })
            } else {
                axios.post(`${BASEURL}/api/v1/salesSchool`, inputObj)
                    .then(res => {
                        if (res.status === 200) {
                            swal("Success", "School Created successfully", "success")
                                .then(function () {
                                    history.push("/schoolsData");
                                })
                        }
                    })
                    .catch((err) => {
                        swal('Error in Creating School', err.response?.data || 'Failed to create', 'error');
                        console.log('Create School Error', err);
                    })
            }
        }
    }

    return (
        <div id="wrapper">
            <Sidebar act="schoolsData" />
            {/* Content Wrapper */}
            <div className="content-page">
                {/* Main Content */}
                <div className="content">
                    <Topbar act={heading} breadcrumbItems={["Sales App", { label: "Schools Data", path: "schoolsData" }, heading]} />
                    {/* container */}
                    {/* content */}
                    <div className="container-fluid main-container">
                        <div className="card main-card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="schoolName" className="form-label">School Name *</label>
                                            <input type="text" id="schoolName" className="form-control" onChange={handleChange}
                                                name="schoolName" placeholder="Enter School Name" value={schoolName} />
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="contactPersonName" className="form-label">Contact Person Name</label>
                                            <input type="text" id="contactPersonName" className="form-control" onChange={handleChange}
                                                name="contactPersonName" placeholder="Enter Contact Person Name" value={contactPersonName} />
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="contactPersonDesignation" className="form-label">Contact Person Designation</label>
                                            <input type="text" id="contactPersonDesignation" className="form-control" onChange={handleChange}
                                                name="contactPersonDesignation" placeholder="Enter Contact Person Designation" value={contactPersonDesignation} />
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="cellNo" className="form-label">Cell No</label>
                                            <input type="text" id="cellNo" className="form-control" onChange={handleChange}
                                                name="cellNo" placeholder="Enter Cell No" value={cellNo} />
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="officeNo" className="form-label">Office No</label>
                                            <input type="text" id="officeNo" className="form-control" onChange={handleChange}
                                                name="officeNo" placeholder="Enter Office No" value={officeNo} />
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State *</label>
                                        <select id="state" className="form-control" name='state' onChange={handleChange} value={state}>
                                            <option value="">Select State</option>
                                            {states.map((state, idx) =>
                                                <option value={state.isoCode} key={idx}>{state.name}</option>
                                            )}
                                        </select>
                                        {/* {stateError ? <p className="errTxt">State is Required</p> : ''} */}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City *</label>
                                        <select id="city" className="form-control" name='city' onChange={handleChange} value={city}>
                                            <option value="">Select City</option>
                                            {cities.map((cityName, idx) =>
                                                <option value={cityName} key={idx}>{cityName}</option>
                                            )}
                                        </select>
                                        {/* {cityError ? <p className="errTxt">City is Required</p> : ''} */}
                                        </div>
                                    </div>

                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="address" className="form-label">Address</label>
                                            <textarea id="address" className="form-control" onChange={handleChange}
                                                name="address" placeholder="Enter Address" value={address} />
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="strengthLKGTo5th" className="form-label">Strength LKG to 5th</label>
                                            <input type="number" id="strengthLKGTo5th" className="form-control" onChange={handleChange}
                                                name="strengthLKGTo5th" placeholder="Enter Strength LKG to 5th" value={strengthLKGTo5th} />
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="strengthLKGTo10th" className="form-label">Strength LKG to 10th</label>
                                            <input type="number" id="strengthLKGTo10th" className="form-control" onChange={handleChange}
                                                name="strengthLKGTo10th" placeholder="Enter Strength LKG to 10th" value={strengthLKGTo10th} />
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="boardType" className="form-label">Board Type</label>
                                            <select id="boardType" className="form-control" onChange={handleChange}
                                                name="boardType" value={boardType}>
                                                <option value="">Select</option>
                                                <option value="CBSE">CBSE</option>
                                                <option value="ICSE">ICSE</option>
                                                <option value="SSC">SSC</option>
                                                <option value="IB">IB</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="currentPublisher" className="form-label">Current Publisher</label>
                                            <input type="text" id="currentPublisher" className="form-control" onChange={handleChange}
                                                name="currentPublisher" placeholder="Enter Current Publisher" value={currentPublisher} />
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="currentDistributor" className="form-label">Current Distributor</label>
                                            <Select
                                                name="currentDistributor"
                                                options={distributors}
                                                value={currentDistributor}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                onChange={handleChangeDistributor}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="bookSellingType" className="form-label">Book Selling Type</label>
                                            <select id="bookSellingType" className="form-control" onChange={handleChange}
                                                name="bookSellingType" value={bookSellingType}>
                                                <option value="">Select</option>
                                                <option value="Individual System">Individual System</option>
                                                <option value="Term System">Term System</option>
                                                <option value="Sem System">Sem System</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="notes" className="form-label">Notes</label>
                                            <textarea id="notes" className="form-control" onChange={handleChange}
                                                name="notes" placeholder="Enter Notes" value={notes} />
                                        </div>
                                    </div>

                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label>Upload School Picture</label>
                                            <MyDropzone file={schoolPic} setFile={setSchoolPic} setError={setSchoolPicError} fromPage="addSchoolDataPage" />
                                            {schoolPicError ? <p className="errTxt">School Pic is Required</p> : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 d-flex">
                                    <button type="submit" className="btn btn-customprimary" onClick={handleSubmit}>{uuid ? 'Update' : 'Create'}</button>
                                    <button type="button" style={{ color: '#6c757d' }} className="btn" onClick={() => {history.push('/schoolsData')}}>Cancel</button>
                                </div>
                                {/* end row */}
                            </div> {/* end card-body */}
                        </div> {/* end card*/}
                    </div>
                    {/* End of Main Content */}
                    <Footer />
                </div>
                {/* End of Content Wrapper */}
            </div>
        </div>
    );
}

export default AddSchoolData;